import { Pill } from "PFComponents/pill";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { Activity, ActivityStatistics } from "PFTypes";

type RoleVacanciesBadgeProps = {
  role: Pick<Activity, "coowned"> & { statistics?: ActivityStatistics };
};

export const RoleVacanciesBadge = ({ role }: RoleVacanciesBadgeProps) => {
  if (!role.coowned || !role.statistics) {
    return null;
  }

  const openVacancies = getAttribute(role.statistics, "openVacanciesCount") ?? 0;
  const totalVacancies = getAttribute(role.statistics, "totalVacanciesCount") ?? 0;
  const message = `${openVacancies} / ${totalVacancies}`;

  return <Pill small text={message} />;
};
